import React from 'react';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import PointsIcon from '@wix/da-ds/pkg/Icons/Points';
import { useTranslation } from 'react-i18next';
import { getDeviationPrice } from '../../../helpers';
import DetailsRightSide from '../../../layouts/DetailsRightSide';
import s from './AdoptableDetailsRightSide.scss';
const AdoptableDetailsRightSide = ({ deviation, hideSold, hidePrice })=>{
    var _deviation_adoptable_offers, _deviation_adoptable;
    const { t } = useTranslation();
    const { dollarsPrice: fixedDollarsPrice, pointsPrice: fixedPointsPrice } = getDeviationPrice(deviation);
    const offerPrice = (_deviation_adoptable = deviation.adoptable) === null || _deviation_adoptable === void 0 ? void 0 : (_deviation_adoptable_offers = _deviation_adoptable.offers) === null || _deviation_adoptable_offers === void 0 ? void 0 : _deviation_adoptable_offers.offerPrice;
    if (!deviation.adoptable) {
        return null;
    }
    const { thumbSaleState, thumbSaleType } = deviation.adoptable;
    const isFixedPriceOnly = thumbSaleType === 'fixed';
    const isOffersOnly = thumbSaleType === 'offer';
    const isOffersAndFixedPrice = thumbSaleType === 'both';
    const renderOfferPriceInDollars = (prefix = '')=>hidePrice ? null : `${prefix}$${offerPrice}`;
    const renderFixedPriceInDollars = (prefix = '')=>hidePrice ? null : `${prefix}$${parseInt(fixedDollarsPrice)}`;
    const renderFixedPriceInPoints = ()=>hidePrice ? null : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(PointsIcon, {
            size: IconSize.TINY,
            disableDefaultColors: true
        }), fixedPointsPrice);
    const renderSold = ()=>hideSold ? null : /*#__PURE__*/ React.createElement("div", {
            className: s['warning']
        }, t('shop.thumb.adoptable.status.sold'));
    // default values we fallback to
    let firstRow = renderFixedPriceInDollars();
    let secondRow = renderFixedPriceInPoints();
    if (isFixedPriceOnly) {
        // FIXED PRICE
        if (thumbSaleState === 'unlisted') {
            // Unlisted
            secondRow = /*#__PURE__*/ React.createElement("div", {
                className: s['warning']
            }, t('shop.thumb.adoptable.status.saleEnded'));
        } else if (thumbSaleState === 'sold') {
            // Sold
            secondRow = renderSold();
        }
    } else if (isOffersOnly) {
        // OFFERS
        if (thumbSaleState === 'open') {
            // Open
            firstRow = renderOfferPriceInDollars();
            secondRow = t('shop.thumb.adoptable.CTA.startingOffer');
        } else if (thumbSaleState === 'pending') {
            // Pending
            firstRow = t('shop.thumb.adoptable.CTA.offersLocked');
            secondRow = t('shop.thumb.adoptable.status.pending');
        } else if (thumbSaleState === 'expired') {
            // Expired
            firstRow = /*#__PURE__*/ React.createElement(React.Fragment, null, " ");
            secondRow = /*#__PURE__*/ React.createElement("div", {
                className: s['warning']
            }, t('shop.thumb.adoptable.status.expired'));
        } else if (thumbSaleState === 'unlisted') {
            // Unlisted
            firstRow = /*#__PURE__*/ React.createElement(React.Fragment, null, " ");
            secondRow = /*#__PURE__*/ React.createElement("div", {
                className: s['warning']
            }, t('shop.thumb.adoptable.status.saleEnded'));
        } else if (thumbSaleState === 'sold') {
            // Sold
            firstRow = renderOfferPriceInDollars();
            secondRow = renderSold();
        }
    } else if (isOffersAndFixedPrice) {
        // OFFERS & FIXED PRICE
        if (thumbSaleState === 'open') {
            // Open
            firstRow = t('shop.thumb.adoptable.CTA.bestOffer');
            secondRow = renderFixedPriceInDollars(/* prefix */ 'or ');
        } else if (thumbSaleState === 'pending') {
            // Pending
            firstRow = renderFixedPriceInDollars();
            secondRow = t('shop.thumb.adoptable.CTA.buyItNow');
        } else if (thumbSaleState === 'expired') {
            // Expired
            firstRow = renderFixedPriceInDollars();
            secondRow = t('shop.thumb.adoptable.CTA.buyItNow');
        } else if (thumbSaleState === 'unlisted') {
            // Unlisted
            firstRow = /*#__PURE__*/ React.createElement(React.Fragment, null, " ");
            secondRow = /*#__PURE__*/ React.createElement("div", {
                className: s['warning']
            }, t('shop.thumb.adoptable.status.saleEnded'));
        } else if (thumbSaleState === 'sold') {
            // Sold
            firstRow = renderFixedPriceInDollars();
            secondRow = renderSold();
        }
    }
    return /*#__PURE__*/ React.createElement(DetailsRightSide, {
        firstRow: firstRow,
        secondRow: secondRow,
        secondRowClassName: s['row-gap']
    });
};
AdoptableDetailsRightSide.displayName = 'AdoptableDetailsRightSide';
export default AdoptableDetailsRightSide;

//# sourceMappingURL=AdoptableDetailsRightSide.js.map